import { Button } from "../../components/ui/button";
import {
  Card,
  CardContent,
  CardHeader,
  CardTitle,
} from "../../components/ui/card";
import { Textarea } from "../../components/ui/textarea";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import productimg2 from "../../product-03-330x440.png";
function ProductDetails() {
  return (
    <>
      <div className="space-y-6">
        <div className="flex items-center gap-4">
          <Link to="/adminproducts">
            <Button variant="outline" size="sm">
              <ArrowLeft className="h-4 w-4" />
            </Button>
          </Link>
          <div>
            <h1 className="text-2xl font-bold text-gray-900">
              Product Details
            </h1>
            <p className="text-gray-600">
              Provide comprehensive information about the product
            </p>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-1 gap-6">
          {/* AI Analysis Panel */}
          <div className="lg:col-span-2 space-y-4">
            {/* AI Analysis Summary */}
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Product Description</CardTitle>
              </CardHeader>
              <CardContent>
                <div class="grid grid-cols-2 md:grid-cols-5 gap-4 mb-4">
                  <div class="text-center p-4 bg-slate-50 rounded-lg">
                    <div class="text-xl font-bold text-slate-900">180</div>
                    <div class="text-sm text-slate-600">Regular price($)</div>
                  </div>
                  <div class="text-center p-4 bg-slate-50 rounded-lg">
                    <div class="text-xl font-bold text-success">150</div>
                    <div class="text-sm text-slate-600">
                      Promotional price($)
                    </div>
                  </div>
                  <div class="text-center p-4 bg-slate-50 rounded-lg">
                    <div class="text-xl font-bold text-slate-900">12</div>
                    <div class="text-sm text-slate-600">Tax rate(%)</div>
                  </div>
                  <div class="text-center p-4 bg-slate-50 rounded-lg">
                    <div class="text-xl font-bold text-slate-900">
                      Mental Health
                    </div>
                    <div class="text-sm text-slate-600">Categories</div>
                  </div>
                  <div class="text-center p-4 bg-slate-50 rounded-lg">
                    <div class="text-xl font-bold text-slate-900">SF09281</div>
                    <div class="text-sm text-slate-600">Sku Code</div>
                  </div>
                </div>
                <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mb-6 items-center">
                  {/* Left column: Product Image */}
                  <div className="flex justify-center items-center custom-bg rounded">
                    <img
                      src={productimg2}
                      alt="productimg"
                      className="w-50 object-cover rounded"
                    />
                  </div>

                  {/* Right columns: Product Details */}
                  <div className="md:col-span-3 space-y-3">
                    <div>
                      <label className="text-sm font-medium text-slate-900">
                        Product Name
                      </label>
                      <p className="text-sm text-slate-700">
                        Minoxidil / Finasteride / Ketoconazole
                      </p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-slate-900">
                        Sku Code
                      </label>
                      <p className="text-sm text-slate-700">SF09281</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-slate-900">
                        Currency
                      </label>
                      <p className="text-sm text-slate-700">USD</p>
                    </div>
                    <div>
                      <label className="text-sm font-medium text-slate-900">
                        Product Description
                      </label>
                      <p className="text-sm text-slate-700">
                        Niacinamide and Vitamin C are two anti-aging superstars
                        but not usually formulated together because of their
                        different pH levels. Niacinamide and Vitamin C are two
                        anti-aging superstars but not usually formulated
                        together because of their different pH levels.
                      </p>
                    </div>
                  </div>
                </div>
              </CardContent>
            </Card>
          </div>
        </div>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-6">
          <div className="lg:col-span-1 space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">Product Details</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-medium text-slate-900 flex items-center pb-2">
                  For Normal, Oily, Combination Skin Types
                </p>
                <p className="text-sm text-slate-700">
                  Complexion-perfecting natural foundation enriched with
                  antioxidant-packed superfruits, vitamins, and other
                  skin-nourishing nutrients. Creamy liquid formula sets with a
                  pristine matte finish for soft, velvety smooth skin.
                </p>
                <p className="pt-2 text-sm text-slate-700">
                  Say hello to flawless, long-lasting foundation that comes in 7
                  melt-into-your-skin shades. This lightweight, innovative
                  formula creates a smooth, natural matte finish that won’t
                  settle into lines. It’s the perfect fit for your skin. 1 fl.
                  oz.
                </p>
                <p className="font-medium text-slate-900 flex items-center pt-2 pb-2">
                  Benefits
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li className="text-sm text-slate-700">
                    Buildable medium-to-full coverage
                  </li>
                  <li className="text-sm text-slate-700">
                    Weightless, airy feel—no caking!
                  </li>
                  <li className="text-sm text-slate-700">Long-wearing</li>
                  <li className="text-sm text-slate-700">Evens skin tone</li>
                  <li className="text-sm text-slate-700">
                    Available in 07 shades (all exclusive to Makeaholic!)
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
          <div className="lg:col-span-1 space-y-6">
            <Card>
              <CardHeader>
                <CardTitle className="text-lg">How to Use</CardTitle>
              </CardHeader>
              <CardContent>
                <p className="font-medium text-slate-900 flex items-center pb-2">
                  Follow these safety guidelines when using cosmetics products
                  of any type:
                </p>
                <ul className="list-disc pl-5 space-y-2">
                  <li className="text-sm text-slate-700">
                    Read the label. Follow all directions and heed all warnings.
                  </li>
                  <li className="text-sm text-slate-700">
                    Wash your hands before you use the product.
                  </li>
                  <li className="text-sm text-slate-700">
                    Do not share makeup.
                  </li>
                  <li className="text-sm text-slate-700">
                    Keep the containers clean and tightly closed when not in
                    use, and protect them from temperature extremes.
                  </li>
                  <li className="text-sm text-slate-700">
                    Throw away cosmetics if there are changes in color or smell.
                  </li>
                  <li className="text-sm text-slate-700">
                    Use aerosols or sprays cans in well-ventilated areas. Do not
                    use them while you are smoking or near an open flame. It
                    could start a fire.
                  </li>
                </ul>
              </CardContent>
            </Card>
          </div>
        </div>
      </div>
    </>
  );
}
export default ProductDetails;
